import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useCurrentUserDetails } from '../../entities/user/model';
import { ROLES } from '../../shared/hooks';
import { useOrgIntegrations } from 'features/organization/integrations/useOrgIntegrations';

export const useItems = () => {
  const { getQBOIntegration } = useOrgIntegrations();
  const { getCurrentOrganizationId, getCurrentOrgRole } =
    useCurrentUserDetails();
  const { getAccessTokenSilently } = useAuth0();
  const query = useQuery({
    queryKey: ['quickbooks-items'],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const resp = await axios.get<string, any>(
        `${process.env.REACT_APP_SERVER_URL}/api/public/quick-books-online/item/list`,
        {
          params: { organizationId: getCurrentOrganizationId() },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return resp.data?.result;
    },
    retry: 3,
    enabled:
      !!getCurrentOrganizationId() &&
      !!getQBOIntegration() &&
      [ROLES.ADMIN, ROLES.ACCOUNTANT].includes(getCurrentOrgRole()),
  });

  return {
    items: query.data || [],
  };
};
